import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-rapoarte-jurnal-search',
  templateUrl: './rapoarte-jurnal-search.component.html',
  styleUrls: ['./rapoarte-jurnal-search.component.scss']
})
export class RapoarteJurnalSearchComponent implements OnInit, OnDestroy {
  @Output() searchResult = new EventEmitter();

  rapoarteJurnalSearchForm;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor() {}

  ngOnInit(): void {
    this.rapoarteJurnalSearchForm = new UntypedFormGroup({
      data_start: new UntypedFormControl(null, Validators.required),
      data_end: new UntypedFormControl(null, Validators.required),
    });
  }

  onSubmitted() {
    if (!this.rapoarteJurnalSearchForm.valid) {
      return;
    }
    this.searchResult.emit(this.rapoarteJurnalSearchForm.value);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }

  resetSearch() {
    this.rapoarteJurnalSearchForm.reset();
    this.onSubmitted();
  }

  onStartDateChanged(event) {
    if (this.rapoarteJurnalSearchForm) {
      this.rapoarteJurnalSearchForm.controls.data_start.setValue(event);
    }
  }

  onEndDateChanged(event) {
    if (this.rapoarteJurnalSearchForm) {
      this.rapoarteJurnalSearchForm.controls.data_end.setValue(event);
    }
  }
}
